import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { DeductionINvoiceSection } from '../../components/deduction-invoice-section.component';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

function DeductionPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='deduction-invoice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='px-3'>
                        <h3 className="dashboard-page__title">{t('DEDUCTIONS_LABEL')}</h3>
                        <DeductionINvoiceSection
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default DeductionPage;
